import customerPortalApiService from '../services/customerPortalApi';
import { getCustomerPortalApi } from '../config';

// Get customer portal API configuration
const customerPortalApi = getCustomerPortalApi();
const EXTERNAL_API_PATH = '/api/external';

/**
 * Authenticate account by phone number
 */
export async function authenticateAccount(accountNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/authenticate`, {
      account_number: accountNumber,
      authenticate: true,
    });
    return response.data;
  } catch (error) {
    console.error('Error authenticating account:', error);
    throw error;
  }
}

/**
 * Get authenticated account details
 */
export async function getAuthenticatedAccount(accountNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/account-status`, {
      account_number: accountNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error getting authenticated account:', error);
    throw error;
  }
}

/**
 * Get account comments
 */
export async function getAccountComments(accountNumber, commentUser = '') {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/comments`, {
      account_number: accountNumber,
      comment_user: commentUser
    });
    return response.data;
  } catch (error) {
    console.error('Error getting account comments:', error);
    throw error;
  }
}

/**
 * Add comment to account
 */
export async function addAccountComment(accountNumber, commentText, commentUser, commentTime) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/add-comment`, {
      account_number: accountNumber,
      comment: commentText,
      user: commentUser,
      time: commentTime
    });
    return response.data;
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error;
  }
}


/**
 * Get statement transactions for a specific billing period
 */
export async function getStatementTransactions(accountNumber, billingDate) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/statement`, {
      account_number: accountNumber,
      billing_date: billingDate
    });
    return response.data;
  } catch (error) {
    console.error('Error getting statement transactions:', error);
    throw error;
  }
}


/**
 * Get available statement months
 */
export async function getAvailableMonths(accountNumber, billingDate) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/statement-months`, {
      account_number: accountNumber,
      billing_date: billingDate
    });
    return response.data;
  } catch (error) {
    console.error('Error getting available months:', error);
    throw error;
  }
}

/**
 * Get statement data for a specific period
 */
export async function getStatementData(accountNumber, billingDate) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/statement`, {
      account_number: accountNumber,
      billing_date: billingDate
    });
    return response.data;
  } catch (error) {
    console.error('Error getting statement data:', error);
    throw error;
  }
}

/**
 * Get account status information
 */
export async function getAccountStatus(accountNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/account-status`, {
      account_number: accountNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error getting account status:', error);
    throw error;
  }
}

/**
 * Get application status
 */
export async function getApplicationStatus(applicationNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/application-status`, {
      application_number: applicationNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error getting application status:', error);
    throw error;
  }
}

/**
 * Get issue status
 */
export async function getIssueStatus(issueNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/follow-up`, {
      type: 'issue',
      number: issueNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error getting issue status:', error);
    throw error;
  }
}

/**
 * Get balance information with statements
 */
export async function getBalanceInfo(accountNumber, billingDate) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/balance-info`, {
      account_number: accountNumber,
      billing_date: billingDate,
      getBalance: true
    });
    return response.data;
  } catch (error) {
    console.error('Error getting balance info:', error);
    throw error;
  }
}

/**
 * Get statement months for dropdown
 */
export async function getStatementMonths(accountNumber, billingDate) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/statement-months`, {
      account_number: accountNumber,
      billing_date: billingDate
    });
    return response.data;
  } catch (error) {
    console.error('Error getting statement months:', error);
    throw error;
  }
}

/**
 * Get graph data for consumption
 */
export async function getGraphData(accountNumber, billingDate) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/graph-data`, {
      account_number: accountNumber,
      billing_date: billingDate
    });
    return response.data;
  } catch (error) {
    console.error('Error getting graph data:', error);
    throw error;
  }
}

/**
 * Get account transactions
 */
export async function getAccountTransactions(accountNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/transactions`, {
      account_number: accountNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error getting account transactions:', error);
    throw error;
  }
}

/**
 * Get account balance
 */
export async function getAccountBalance(accountNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/balance`, {
      account_number: accountNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error getting account balance:', error);
    throw error;
  }
}

/**
 * Get recent statements
 */
export async function getRecentStatements(accountNumber, billingDate) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/balance-info`, {
      account_number: accountNumber,
      today: billingDate
    });
    return response.data;
  } catch (error) {
    console.error('Error getting recent statements:', error);
    throw error;
  }
}

 
export async function sendOtp(phoneNumber, dev) { 
  try { 
     const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/send_otp`, {
      phone_number: phoneNumber,
      //dev: dev,
      send_otp: true,
    }); 
    return { status: 1, message: 'OTP sent successfully' };
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
}

export async function verifyOtp(phoneNumber, otpCode) {
  // This would still use the original API for OTP functionality
  try {
         const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/verify_otp`, {
        phone_number: phoneNumber, 
        check_otp: otpCode,
        verify_otp: true,
    }); 
    return { status: 1, message: 'OTP verified successfully' };
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
}

/**
 * Get account details (replacement for GetAccount bridge call)
 */
export async function getAccountDetails(accountNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/account-details`, {
      account_number: accountNumber,
      authenticated: true
    });
    return response.data;
  } catch (error) {
    console.error('Error getting account details:', error);
    throw error;
  }
}

/**
 * Get transactions for payment link (replacement for PaymentLink bridge call)
 */
export async function getPaymentTransactions(accountNumber) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/payment-transactions`, {
      account_number: accountNumber,
      getTransactions: true
    });
    return response.data;
  } catch (error) {
    console.error('Error getting payment transactions:', error);
    throw error;
  }
}

export async function authenticateAccountData(accountData) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/authenticate`, {
      phone: accountData.phone || accountData.account_number
    });
    return response.data;
  } catch (error) {
    console.error('Error authenticating account data:', error);
    throw error;
  }
}

/**
 * Generate payment link for Ozow
 */
export async function generatePaymentLink(paymentData) {
  try {
    const response = await customerPortalApiService.post(`${EXTERNAL_API_PATH}/payment-link`, paymentData);
    return response.data;
  } catch (error) {
    console.error('Error generating payment link:', error);
    throw error;
  }
}

// Default export for backward compatibility with existing imports
const externalApi = {
  authenticateAccount,
  getAuthenticatedAccount,
  getAccountComments,
  addAccountComment,
  getAccountTransactions,
  getStatementTransactions,
  getAvailableMonths,
  getStatementData,
  getAccountStatus,
  getApplicationStatus,
  getIssueStatus,
  getBalanceInfo,
  getRecentStatements,
  getAccountBalance,
  getStatementMonths,
  getGraphData,
  sendOtp,
  verifyOtp,
  authenticateAccountData,
  getAccountDetails,
  getPaymentTransactions,
  generatePaymentLink
};

export default externalApi;
